import { render } from "./BulkLiquidHandling.vue?vue&type=template&id=b15fbfee"
import script from "./BulkLiquidHandling.vue?vue&type=script&lang=js"
export * from "./BulkLiquidHandling.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__